import React, { Children } from "react"
import { graphql, Link } from "gatsby"
import Obfuscate from 'react-obfuscate';

import Layout from "../components/layout"
import SEO from "../components/seo"

function ArticleCard(props){
  return(
    <ul className="md:w-1/3 mx-2 mb-12 px-4 border-gray-600 border-b pb-6 pt-6">
      <div className="flex items-center">
        {props.icon}
        <h3 className="font-bold text-xl text-bold mb-2">{props.title}</h3>
      </div>
      <div className="text-sm">{props.children}</div>
    </ul>
  )
}

class Contact extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Contact"
        />
        <div className="container mx-auto max-w-5xl">
          <h1 className="my-4 text-2xl md:text-3xl font-black leading-tight">
            Contact
          </h1>
          <p className="leading-normal text-gray-800 text-base md:text-xl mb-8">
            Please get in touch by any of the methods below.
          </p>
        </div>

        <section className="bg-gray-100 border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap justify-center mx-2">
            <ArticleCard
              title="Email"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"/>
                </svg>
              }
            >
              <div className="py-2">
                Please get in touch to discuss membership, publication, or anything else related to the WCCA.
              </div>
              <div className="text-blue-600">
                <Obfuscate
                  email="contact@webcontentcreatorsassociation.org"
                />
              </div>
            </ArticleCard>
            <ArticleCard
              title="Call"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 122.879 122.785" enable-background="new 0 0 122.879 122.785"><g><path d="M29.789,59.399c3.635,6.556,7.821,12.852,13.274,18.597c5.452,5.777,12.236,11.035,21.031,15.515 c0.649,0.324,1.266,0.324,1.817,0.097c0.844-0.324,1.688-1.006,2.532-1.85c0.649-0.649,1.46-1.688,2.305-2.824 c3.375-4.447,7.563-9.964,13.469-7.205c0.13,0.064,0.228,0.13,0.357,0.194l19.7,11.327c0.065,0.032,0.131,0.098,0.195,0.13 c2.597,1.785,3.667,4.544,3.699,7.66c0,3.181-1.168,6.75-2.888,9.769c-2.272,3.992-5.615,6.621-9.478,8.374 c-3.667,1.688-7.757,2.597-11.685,3.181c-6.166,0.908-11.943,0.324-17.851-1.493c-5.777-1.784-11.587-4.738-17.948-8.665 l-0.454-0.293c-2.921-1.817-6.069-3.765-9.152-6.068c-11.328-8.537-22.849-20.87-30.347-34.437 c-6.297-11.392-9.737-23.693-7.854-35.41c1.039-6.426,3.797-12.268,8.601-16.13c4.187-3.375,9.834-5.226,17.136-4.576 c0.844,0.064,1.59,0.552,1.98,1.265l12.625,21.356c1.851,2.402,2.077,4.771,1.071,7.14c-0.844,1.948-2.531,3.733-4.836,5.42 c-0.681,0.584-1.492,1.168-2.336,1.785c-2.824,2.045-6.037,4.414-4.934,7.206L29.789,59.399L29.789,59.399L29.789,59.399z M107.916,18c2.594,0,4.696,2.103,4.696,4.696s-2.103,4.696-4.696,4.696s-4.696-2.103-4.696-4.696S105.322,18,107.916,18 L107.916,18z M75.697,17.983c2.6,0,4.707,2.107,4.707,4.706s-2.107,4.705-4.707,4.705s-4.704-2.106-4.704-4.705 S73.098,17.983,75.697,17.983L75.697,17.983z M92.384,17.983c2.6,0,4.707,2.107,4.707,4.706s-2.107,4.705-4.707,4.705 s-4.705-2.106-4.705-4.705S89.784,17.983,92.384,17.983L92.384,17.983z M73.012,0c-3.518,0-6.527,1.238-9.031,3.714 s-3.714,5.486-3.714,9.032v22.368c0,3.545,1.237,6.555,3.714,9.032c2.476,2.476,5.486,3.713,9.031,3.713h10.472 c-0.731,2.813-1.632,5.486-2.757,7.99c-1.098,2.533-2.982,4.952-5.571,7.259c4.98-1.294,9.397-3.235,13.308-5.796 c3.884-2.532,7.26-5.711,10.045-9.454h11.626c3.518,0,6.528-1.266,9.032-3.713c2.504-2.477,3.713-5.487,3.713-9.032V12.746 c0-3.518-1.237-6.528-3.713-9.032C116.689,1.21,113.68,0,110.134,0C98.822,0,84.324,0,73.012,0L73.012,0L73.012,0z"/></g></svg>
              }
            >
              <p className="py-2">
                For urgent enquiries regarding billing or membership, please give us a call on:
              </p>
              <div className="text-blue-600">
                <Obfuscate
                  tel="+852 5431 6330"
                  linkText="Click-to-call"
                />
              </div>
              <p className="py-2">
                We are available between 7am and 1pm GMT Monday through Friday.
              </p>
            </ArticleCard>
            <ArticleCard
              title="Verify"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current"
                  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 122.879 122.785" enable-background="new 0 0 122.879 122.785"><g><path d="M34.388,67.984c-0.286-0.308-0.542-0.638-0.762-0.981c-0.221-0.345-0.414-0.714-0.573-1.097 c-0.531-1.265-0.675-2.631-0.451-3.934c0.224-1.294,0.812-2.531,1.744-3.548l0.34-0.35c2.293-2.185,5.771-2.592,8.499-0.951 c0.39,0.233,0.762,0.51,1.109,0.827l0.034,0.031c1.931,1.852,5.198,4.881,7.343,6.79l1.841,1.651l22.532-23.635 c0.317-0.327,0.666-0.62,1.035-0.876c0.378-0.261,0.775-0.482,1.185-0.661c0.414-0.181,0.852-0.323,1.3-0.421 c0.447-0.099,0.903-0.155,1.356-0.165h0.026c0.451-0.005,0.893,0.027,1.341,0.103c0.437,0.074,0.876,0.193,1.333,0.369 c0.421,0.161,0.825,0.363,1.207,0.604c0.365,0.231,0.721,0.506,1.056,0.822l0.162,0.147c0.316,0.313,0.601,0.653,0.85,1.014 c0.256,0.369,0.475,0.766,0.652,1.178c0.183,0.414,0.325,0.852,0.424,1.299c0.1,0.439,0.154,0.895,0.165,1.36v0.23 c-0.004,0.399-0.042,0.804-0.114,1.204c-0.079,0.435-0.198,0.863-0.356,1.271c-0.16,0.418-0.365,0.825-0.607,1.21 c-0.238,0.377-0.518,0.739-0.832,1.07l-27.219,28.56c-0.32,0.342-0.663,0.642-1.022,0.898c-0.369,0.264-0.767,0.491-1.183,0.681 c-0.417,0.188-0.851,0.337-1.288,0.44c-0.435,0.104-0.889,0.166-1.35,0.187l-0.125,0.003c-0.423,0.009-0.84-0.016-1.241-0.078 l-0.102-0.02c-0.415-0.07-0.819-0.174-1.205-0.31c-0.421-0.15-0.833-0.343-1.226-0.575l-0.063-0.04 c-0.371-0.224-0.717-0.477-1.032-0.754l-0.063-0.06c-1.58-1.466-3.297-2.958-5.033-4.466c-3.007-2.613-7.178-6.382-9.678-9.02 L34.388,67.984L34.388,67.984z M61.44,0c16.96,0,32.328,6.883,43.453,17.987c11.104,11.125,17.986,26.493,17.986,43.453 c0,16.961-6.883,32.329-17.986,43.454C93.769,115.998,78.4,122.88,61.44,122.88c-16.961,0-32.329-6.882-43.454-17.986 C6.882,93.769,0,78.4,0,61.439C0,44.48,6.882,29.112,17.986,17.987C29.112,6.883,44.479,0,61.44,0L61.44,0z M96.899,25.981 C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685c-9.073,9.073-14.684,21.609-14.684,35.458 c0,13.851,5.611,26.387,14.684,35.46s21.609,14.685,35.46,14.685c13.85,0,26.386-5.611,35.459-14.685s14.684-21.609,14.684-35.46 C111.583,47.59,105.973,35.054,96.899,25.981L96.899,25.981z"/></g></svg>
              }
            >
              <div className="py-2">
                To verify the status of a content creator claiming to be a member of the WCCA, please send us an email here:
              </div>
              <div className="text-blue-600">
                <Obfuscate
                  email="verify@webcontentcreatorsassociation.org"
                />
              </div>
            </ArticleCard>

            <ArticleCard
              title="Post"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9 12H1v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6h-8v2H9v-2zm0-1H0V5c0-1.1.9-2 2-2h4V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h4a2 2 0 0 1 2 2v6h-9V9H9v2zm3-8V2H8v1h4z"/>
                </svg>
              }
            >
              <div className="py-2">
                Please address mail to:
              </div>
              <div className="pl-2">
                Web Content Creators Association<br/>
                Level 5, 212 Gloucester Road<br/>
                Wan Chai, Hong Kong
              </div>
            </ArticleCard>
          </div>
        </section>
      </Layout>
    )
  }
}

export default Contact

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`